module.exports = __webpack_public_path__ + "static/testimonial-4-48b6e36b66b4ee3bdbf6b9278bd108ad.png";